import React from "react";
import '../assets/css/Tour360.css'

const Tour360 = () => {
    const preventIframeRedirect = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <div className="full-container">
            <iframe title="360 tour" src="https://surbhi-infotech.s3.ap-south-1.amazonaws.com/3D_Vista/Tirupati_Namaah/index.htm" widh={"100%"} height={"100%"} className="tour-iframe" onDoubleClick={preventIframeRedirect} allow="xr-spatial-tracking fullscreen" />
        </div>
    )
}

export default Tour360;